import useEmblaCarousel from "embla-carousel-react";
import { useCallback, useEffect, useState } from "react";
import { useDevice } from "~/lib/hooks/useDevice";

export const useSlider = () => {
	const { mobile } = useDevice();
	const [prevBtnEnabled, setPrevBtnEnabled] = useState(false);
	const [nextBtnEnabled, setNextBtnEnabled] = useState(false);
	const [emblaRef, emblaApi] = useEmblaCarousel({
		slidesToScroll: 1,
		containScroll: "trimSnaps",
		inViewThreshold: mobile ? 2.3 : 4,
		skipSnaps: true,
		axis: "x",
		align: "start",
		draggable: true,
		loop: false,
		speed: 20,
	});

	const scrollPrev = useCallback(() => emblaApi?.scrollPrev(false), [emblaApi]);
	const scrollNext = useCallback(() => emblaApi?.scrollNext(false), [emblaApi]);
	const scrollTo = useCallback((index: number) => emblaApi?.scrollTo(index), [emblaApi]);

	const onSelect = useCallback(() => {
		if (!emblaApi) return;
		setPrevBtnEnabled(emblaApi.canScrollPrev());
		setNextBtnEnabled(emblaApi.canScrollNext());
	}, [emblaApi]);

	useEffect(() => {
		if (!emblaApi) return;
		onSelect();
		emblaApi.on("select", onSelect);
		emblaApi.on("reInit", onSelect);
	}, [emblaApi, onSelect]);

	return {
		emblaRef,
		prevBtnEnabled,
		nextBtnEnabled,
		scrollPrev,
		scrollNext,
		scrollTo,
	};
};
